export default __webpack_public_path__ + "static/media/journal2image1.074503b6.png";